module.exports = __webpack_public_path__ + "6b3064fb8c9cbc6672f0fe8da4b9b686.jpg";